import { render, staticRenderFns } from "./IgEventTimeline.vue?vue&type=template&id=917369b0&"
import script from "./IgEventTimeline.vue?vue&type=script&lang=js&"
export * from "./IgEventTimeline.vue?vue&type=script&lang=js&"
import style0 from "./IgEventTimeline.vue?vue&type=style&index=0&id=917369b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports